import { Component } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormControlService } from '../../shared/services/form-control.service';
import { Textbox } from '../../models/editors/textbox.model';
import { Textarea } from '../../models/editors/textarea.model';
import { Footer } from '../../models/footer/footer.model';
import { ApiService } from '../../shared/services/api.service';
import { AlertService } from '../../shared/services/alert.service';
import { InlineFormBase } from '../../shared/components/base/inline-form/inline-form.base.component';
import { Contained } from './../../models/editors/contained.model';

@Component({
  selector: 'swb-footer-settings',
  templateUrl: './../../shared/components/base/inline-form/inline-form.base.component.html',
  providers: [FormControlService]
})

export class FooterSettingsComponent extends InlineFormBase<Footer> {

  public url = 'footer';

  public headerTitle = 'Údaje v patičce';

  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'title',
        label: 'Název subjektu',
        validators: [Validators.required],
        isMultilang: true
      }),
      new Textarea({
        key: 'custom',
        label: 'Vlastní text',
        validators: [],
        isMultilang: true,
        wysiwyg: 'footer',
      }),
      new Textbox({
        key: 'email',
        label: 'Kontaktní e-mail',
        validators: [],
        isMultilang: false
      }),
      new Textbox({
        key: 'phone',
        label: 'Mobilní telefon',
        validators: [],
        isMultilang: false
      }),
      new Textbox({
        key: 'phone_fixed',
        label: 'Pevná linka',
        validators: [],
        isMultilang: false
      }),
      new Textbox({
        key: 'address',
        label: 'Adresa',
        validators: [],
        isMultilang: true
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _alertService: AlertService
  ) {
    super(
      _formService,
      _apiService,
      _alertService
    );
  }

}
